exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "*,.footer{margin:0}.footer{width:100%;background-color:#4b74ff;padding:20px 20px 20px 0}.catchprize{height:46px;font-family:NanumBarunGothicOTF;font-size:40px;text-align:right;color:#fcfcfc}.catchprize-2{height:23px;opacity:.5;font-family:NanumBarunGothicUltraLightOTF;font-size:20px;font-style:normal;font-stretch:normal;letter-spacing:normal;text-align:right;color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-637f02f0","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Footer.vue
// module id = 338
// module chunks = 0